<template>
  <section class="container">
    <div class="section-group">
      <div class="row">
        <slot name="left"></slot>
        <slot name="content"></slot>
        <slot name="right"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Social/TempPage.vue